import http from "@/services/http";
import {ref} from 'vue';
import {useAuth} from "@/services/auth.js";

export const orcamentos = () => {
  const auth = useAuth();
  // Mesmo padrão de vendas.js/clientes.js: mensagem real do erro (ex.:
  // sem permissão, orçamento já convertido) pra tela mostrar de verdade.
  const lastErrorMessage = ref(null);

  async function list(status = null) {
    let retorno;
    try {
        let url = '/budgets';
        if (status) url += '?status=' + status;
        const {data} = await http.get(url, auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function create(venda) {
    const dados = {
      customer_id: venda.cliete === 'avulso' ? null : venda.cliete.id,
      items: venda.lista.map(item => ({
        type: item.type ?? 'product',
        id: item.id,
        quant: item.quant,
        price: item.price,
      })),
      description: venda.description || null,
    };
    try {
      const {data} = await http.post('/budgets', dados, auth.getBearer());
      lastErrorMessage.value = null;
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  async function convert(id, paymentMethodId) {
    try {
      const {data} = await http.post('/budgets/' + id + '/convert', { payment_method_id: paymentMethodId }, auth.getBearer());
      lastErrorMessage.value = null;
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, create, convert, lastErrorMessage}
}
